module.exports = __webpack_public_path__ + "img/m-plan-3-BG.e4929351.png";